import { authentication } from '@ecosystem/newron-client-lib';
import saveErrorLog, { ErrorTagEnum } from '@utils/LogUtil';

interface ImpersonationHeader {
  'X-Impersonate-Client': string;
}

interface CurrentClientInfo {
  clientId: number;
  clientUserGroupIds: number[];
}

export const IMPERSONATION_STORAGE_KEY = 'impersonation';
const WAIT_STEP_MS = 100;
const WAIT_MAX_TRIES = 50;

/**
 * Returns the impersonation header to use for API calls.
 */
export async function getImpersonationHeader(): Promise<ImpersonationHeader | null> {
  const isInternalUser = authentication.getUser()?.isInternalUser;
  if (!isInternalUser) {
    return null;
  }
  let tries = 0;
  let storage = localStorage.getItem(IMPERSONATION_STORAGE_KEY);
  while (!storage && tries < WAIT_MAX_TRIES) {
    tries++;
    await new Promise((resolve) => setTimeout(resolve, WAIT_STEP_MS));
    storage = localStorage.getItem(IMPERSONATION_STORAGE_KEY);
  }

  if (storage) {
    return {
      'X-Impersonate-Client': storage,
    };
  }
  const loggerMessage = 'Failed to load impersonation data in time.';
  saveErrorLog(new Error(loggerMessage), `Impersonation error`, {
    category: ErrorTagEnum.FrontEndError,
    requestPayload: {},
    clientId: authentication.getUser()?.clientId,
  });
  return null;
}

//Either Impersonated or login client user
export const getImpersonatedClientUserInfo = (): CurrentClientInfo | null => {
  const storage = localStorage.getItem(IMPERSONATION_STORAGE_KEY);

  //If storage has value and owner is internal user, always use it
  if (storage) {
    const parsed = JSON.parse(storage);
    const clientId = parsed?.client_id;
    const clientUserGroupIds = parsed?.client_user_group_ids.map(Number);
    return { clientId, clientUserGroupIds } as CurrentClientInfo;
  }
  //Return login client info
  return null;
};
